module.exports = __webpack_public_path__ + "img/arrow_up_green_24dp.3aad9bf4.png";